import React, { useState } from 'react';
import { Table, Form, Input, Select, Statistic, Button } from 'antd';
import { LikeOutlined, DislikeOutlined } from '@ant-design/icons';
const { Option } = Select;
var _ = require('lodash');

const columns = [
    {
        title: 'Parameter',
        dataIndex: 'parameter',
        width: 250,
    },
    {
        title: 'Execution Parameter',
        dataIndex: 'sub_parameter',
        render: text => {
            return <p>{text.split("<BR>").map(item => <div>{item}<br /></div>)}</p>
        },
    },
    {
        title: "Feedback",
        dataIndex: "feedback",
        width: 350,
        render: (_, record) => {
            if (record.disabled) {
                return <p>{record.selected_option}</p>
            }
            return <Form.Item
                name={record.key}
                rules={[{ required: true, message: "Please select" }]}
            >
                <Select defaultValue={record.score} disabled={record.disabled} onSelect={(score) => record.updateFunction(record.key, score)}>
                    {record.input_options.map(item => <Option value={item.score}>{item.option}</Option>)}
                </Select>
            </Form.Item>
        },
    },
    {
        title: 'Score',
        dataIndex: 'score',
        width: 200,
        align: "center",
        key: 'score',
    },
];

const parameters = [
    {
        key: 'productivity_improvement',
        parameter: 'Productivity improvement',
        category: 'Improvement & Initiative',
        sub_parameter: 'Any initiative in Productivity:<BR>1) Mechanization of construction job.<BR>2) Mechanization of material handling job.<BR>3) Optimization of logistic/ transportation<BR>4) Use of new age tools/ equipment<BR>5) Other initiaves - Specifty',
        input_options: [{ option: 'Visible results/ implemented', score: 4 }, { option: 'In progress/ effort is there', score: 2 }, { option: 'No effort', score: 0 }],
        score: 0,
        weight: 50,
        weighted_score: 0,
    },
    {
        key: 'cost_reduction',
        parameter: 'Cost reduction initiatives',
        category: 'Improvement & Initiative',
        sub_parameter: 'Any initiative in cost reduction:<BR>1) Implementation of cost reduction initiatives in material deployed<BR>2) Implementation of cost reduction technique in services rendered<BR>3) Other intitiatives - Specify',
        input_options: [{ option: 'Visible results/ implemented', score: 4 }, { option: 'In progress/ effort is there', score: 2 }, { option: 'No effort', score: 0 }],
        score: 0,
        weight: 25,
        weighted_score: 0,
    },
    {
        key: 'compliance',
        parameter: 'Compliances and other initiatives',
        category: 'Improvement & Initiative',
        sub_parameter: 'Compliances and other initiatives:<BR>1) GST complaince/ other tax complainces<BR>2) HR compliances- statutory<BR>3) Any initiative in Safety/Quality/workers welfare/digitization/automation/systems & practices behaviour/ rewards and recognitions etc.',
        input_options: [{ option: 'All 3 requirements fulfilled', score: 4 }, { option: '2 requirements fulfilled', score: 3 }, { option: '1 requirements fulfilled', score: 2 }, { option: 'No requirements fulfilled', score: 0 }],
        score: 0,
        weight: 25,
        weighted_score: 0,
    },
];

const ImprovementFeedback = ({ updateScore, disabled, initialValues }) => {

    const updateData = (key, score) => {
        let count = 0

        let updateData = data.map(item => {
            if (item.key == key) {
                item.score = score
                item.weighted_score = (score * item.weight) / 100
            }
            count = count + item.weighted_score
            return item;
        })
        setWeightedScore(count)
        setData(updateData)
        updateScore("Improvement & Initiative", updateData)
    }

    const [weightedScore, setWeightedScore] = useState(0)

    const [data, setData] = useState(() => {
        let count = 0;
        let updatedParameters = parameters.map(item => {
            item.updateFunction = updateData
            item.disabled = disabled
            if (initialValues) {
                let option = initialValues.scores.filter(x => x.key == item.key)
                if (option.length > 0) {
                    item.selected_option = option[0].selected_option
                    item.score = option[0].score
                    item.weighted_score = option[0].weighted_score
                    count += option[0].weighted_score
                } else {
                    item.selected_option = ""
                }
            }
            return item;
        })
        setWeightedScore(count)
        return updatedParameters;
    });



    return (
        <>
            {!disabled && <>
                <div style={{ padding: "10px", float: "right", marginRight: "15px", background: "white", border: "1px solid lightgray", borderRadius: "10px" }}>
                    <Statistic
                        title="Overall Improvement & Initiative"
                        valueStyle={{ color: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}
                        prefix={weightedScore < 3 ? <DislikeOutlined /> : <LikeOutlined />}
                        value={weightedScore}
                        precision={2} />
                </div>
                <br /><br /><br /><br /></>}
            <div className='form-box' >
                {(initialValues.scores.some(obj => obj.category === 'Improvement & Initiative')) ?
                    <div className='score-legend' 
                    style={{ background: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}>
                        <p style={{ margin: "0px" }}>Overall Improvement & Initiative Score - {weightedScore.toFixed(2)}</p>
                    </div> :
                    <div className='score-legend' style={{ background: '#838383' }}>
                        <p style={{ margin: "0px" }}>Improvement & Initiative Feedack Pending</p>
                    </div>}
                <Table
                    bordered={true}
                    columns={columns}
                    size="small"
                    pagination={false}
                    dataSource={_.cloneDeep(data)} />
            </div>


        </>
    );
}
export default ImprovementFeedback;